import React from 'react';
import { BrokerGroupCountryField } from './BrokerGroupCountryField';
import { BrokerGroupStateField } from './BrokerGroupStateField';
import { BrokerGroupTimezoneField } from './BrokerGroupTimezoneField';
import { Grid, Typography } from '@mui/material';

/** The edit drawer's Location section: country, state (when the country has states) and timezone. */
export const LocationFields = () => (
	<>
		<Grid size={12}>
			<Typography variant='form_label'>Location</Typography>
		</Grid>
		<BrokerGroupCountryField />
		<BrokerGroupStateField />
		<BrokerGroupTimezoneField />
	</>
);
